var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.311946 9.47281L1.45388 10.6324C1.87274 11.0601 2.56054 11.0645 2.98822 10.6456L5.48372 8.18538L7.93954 10.6765C8.3584 11.1041 9.04621 11.1086 9.47388 10.6853L10.6335 9.54335C11.0611 9.12449 11.0655 8.43669 10.6423 8.00901L8.18645 5.51792L10.682 3.05769C11.1096 2.63883 11.114 1.95102 10.6908 1.52335L9.54884 0.363778C9.12998 -0.0638963 8.44217 -0.0683053 8.0145 0.350551L5.519 2.81078L3.06317 0.324097C2.64432 -0.103577 1.95651 -0.107986 1.52884 0.31087L0.369263 1.45281C-0.0584121 1.87166 -0.0628206 2.55947 0.356036 2.98714L2.81186 5.48265L0.316356 7.94288C-0.1025 8.36174 -0.106911 9.04954 0.311946 9.47281Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.13b21ea8.svg";
export { ForwardRef as ReactComponent };